import { useTranslation } from 'react-i18next'
import uniqueId from 'lodash-es/uniqueId'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../constants/common'
import { useNotification } from '../../../../../hooks'
import {
  performMockViewingsMassAction,
  VIEWING_MASS_ACTION,
} from '../../../../RentalPortalViewing'
import { VIEWING_ARCHIVE_UNDO_TIMEOUT } from '../../RentalPortalViewings.constants'

export function useRentalPortalViewingsArchiveUndo({ onReload }) {
  const { t } = useTranslation()

  const {
    handleAddErrorNotification,
    handleAddSuccessNotification,
    handleRemoveNotification,
  } = useNotification()

  function restoreViewing(id) {
    return performMockViewingsMassAction({
      action: VIEWING_MASS_ACTION.restore,
      all: false,
      filters: { archived: true, exclude_id: EMPTY_LIST, id: [id] },
      payload: EMPTY_OBJECT,
    })
      .then(() => {
        handleAddSuccessNotification('Notification.CommonTitleRestoredKey')

        return onReload()
      })
      .catch(() => {
        handleAddErrorNotification('RentalPortal.ViewingArchiveUndoErrorKey')
      })
  }

  function handleAddArchiveUndoNotification(id) {
    const notificationId = uniqueId('viewing-archive-undo-')

    handleAddSuccessNotification({
      id: notificationId,
      textButtonValue: t('RentalPortal.ViewingArchiveUndoBtnKey'),
      timeout: VIEWING_ARCHIVE_UNDO_TIMEOUT,
      title: t('Notification.CommonTitleArchivedKey'),
      onClickTextButton: () => {
        handleRemoveNotification(notificationId)

        return restoreViewing(id)
      },
    })
  }

  return { handleAddArchiveUndoNotification }
}
